// extracted by mini-css-extract-plugin
export default {"products":"jw-z","card":"kw-z","oosMessaging":"lw-z"};